module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('xheader'), _vm._v(" "), _c('xsilde'), _vm._v(" "), _c('tab', {
    attrs: {
      "line-width": 2,
      "active-color": "#fc378c"
    },
    model: {
      value: (_vm.index),
      callback: function($$v) {
        _vm.index = $$v
      },
      expression: "index"
    }
  }, [_c('tab-item', {
    staticClass: "vux-center"
  }, [_c('a', {
    staticClass: "tabLink",
    attrs: {
      "href": '#/app/newSong'
    }
  }, [_vm._v("新歌")])]), _vm._v(" "), _c('tab-item', {
    staticClass: "vux-center"
  }, [_c('a', {
    staticClass: "tabLink",
    attrs: {
      "href": '#/app/range'
    }
  }, [_vm._v("排行")])]), _vm._v(" "), _c('tab-item', {
    staticClass: "vux-center"
  }, [_c('a', {
    staticClass: "tabLink",
    attrs: {
      "href": '#/app/songSheet'
    }
  }, [_vm._v("歌单")])]), _vm._v(" "), _c('tab-item', {
    staticClass: "vux-center"
  }, [_c('a', {
    staticClass: "tabLink",
    attrs: {
      "href": '#/app/singer'
    }
  }, [_vm._v("歌手")])])], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-133ad518"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/App.vue
// module id = 241
// module chunks = 0